(() => {
  const roots = document.querySelectorAll('[data-custom-press]');
  if (!roots.length) return;

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  roots.forEach((root) => {
    const track = root.querySelector('[data-press-track]');
    const prev = root.querySelector('[data-press-prev]');
    const next = root.querySelector('[data-press-next]');
    const cards = root.querySelectorAll('[data-press-card]');
    if (!track || !prev || !next || !cards.length) return;

    /* -------------------------
       Arrows (no autoplay)
    ------------------------- */
    const stepCards = Math.max(1, Number(root.dataset.step || 1));

    const getStepWidth = () => {
      // Use first card width + gap
      const card = cards[0];
      const cardW = card.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap || 0) || 0;
      return cardW + gap;
    };

    const scrollByAmount = (dir) => {
      track.scrollBy({
        left: dir * getStepWidth() * stepCards,
        behavior: 'smooth'
      });
    };

    prev.addEventListener('click', () => scrollByAmount(-1));
    next.addEventListener('click', () => scrollByAmount(1));

    /* -------------------------
       Overlay positioning (only if overlay mode)
    ------------------------- */
    if (!root.classList.contains('custom-press--overlay')) return;

    let activePop = null;

    const hidePop = () => {
      if (activePop) {
        activePop.classList.remove('is-active');
        activePop = null;
      }
    };

    const positionPop = (card) => {
      const pop = card.querySelector('.custom-press__quote-pop');
      if (!pop) return;

      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();

      // Place at carousel height (near track)
      const margin = 12;
      const desiredTop = trackRect.top + 8;
      const top = clamp(desiredTop, margin, window.innerHeight - margin - 80);

      const popWidth = Math.min(560, window.innerWidth * 0.92);
      let left = cardRect.left;
      left = clamp(left, margin, window.innerWidth - margin - popWidth);

      pop.style.top = `${top}px`;
      pop.style.left = `${left}px`;

      if (activePop && activePop !== pop) activePop.classList.remove('is-active');
      activePop = pop;
      pop.classList.add('is-active');
    };

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => positionPop(card));
      card.addEventListener('mouseleave', hidePop);

      card.addEventListener('focusin', () => positionPop(card));
      card.addEventListener('focusout', (e) => {
        if (!card.contains(e.relatedTarget)) hidePop();
      });
    });

    const onReflow = () => {
      if (!activePop) return;
      const activeCard = [...cards].find((c) => c.querySelector('.custom-press__quote-pop') === activePop);
      if (activeCard) positionPop(activeCard);
    };

    window.addEventListener('resize', onReflow, { passive: true });
    window.addEventListener('scroll', onReflow, { passive: true });
    track.addEventListener('scroll', onReflow, { passive: true });
  });
})();
